import moment from "moment";

const generateDOB = ({
  departureStartDate,
  ageFrom = 18,
  ageTo = 99,
  dateFormat = "YYYY-MM-DD",
}) => {
  const fromDOB = moment(departureStartDate)
    .subtract(ageFrom || 18, "years")
    .format("YYYY-MM-DD");

  const toDOB = moment(departureStartDate)
    .subtract(ageTo || 99, "years")
    .format("YYYY-MM-DD");

  const [fromValue, toValue] = [fromDOB, toDOB].map((date) =>
    moment(date, "YYYY-MM-DD").valueOf()
  );
  const diff = fromValue - toValue;
  const randomTimestamp = toValue + Math.random() * diff;

  return moment(randomTimestamp).format(dateFormat || "YYYY-MM-DD");
};

export default generateDOB;
